import _ from 'lodash';

import {
  VENDORS_GET_DASHBOARD_DATA_REQUEST,
  VENDORS_GET_DASHBOARD_DATA_SUCCESS,
  VENDORS_GET_DASHBOARD_DATA_FAILURE
} from './dashboard-actions';

import createReducer from 'state/createReducer';

const initialState = {
  request: false,
  data: [],  
}

const handlers = {
  [VENDORS_GET_DASHBOARD_DATA_REQUEST](state) {
    return {
      ...state,
      request: true
    }
  },

  [VENDORS_GET_DASHBOARD_DATA_SUCCESS](state, payload) {
    return {
      ...state,
      request: false,
      data: payload,
    }
  },

  [VENDORS_GET_DASHBOARD_DATA_FAILURE](state) {
    return {
      ...state,
      request: false
    }
  },

}

export default (state = initialState, action) => createReducer(state, action, handlers);

